import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export function isFetchBaseQueryError(
  error: unknown,
): error is FetchBaseQueryError {
  return typeof error === "object" && error !== null && "status" in error;
}

/**
 * The API's own message for a failed request, or `fallback` when the failure
 * carries none (a network error, or a status rendered without a body).
 *
 * The API answers a refused write with a message written for the customer — "a
 * sync is already running", "Genesys accepted these credentials, but the OAuth
 * client is missing…" — and that is more useful than anything a form can guess.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === "object" && "data" in error) {
    const data = error.data;
    if (data && typeof data === "object" && "message" in data) {
      if (typeof data.message === "string") {
        return data.message;
      }
    }
  }
  return fallback;
}
